module.exports = __webpack_public_path__ + "img/login_tab04_05.af5e2650.png";